import React from 'react';

import { selectCurrentLicenseDetails } from 'selectors/super-admin';
import { FjModal } from 'components/primitives';
import { CloudAdminActions } from 'actions';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { formatDate } from 'utils';

import LicenseDetailSection from './license-detail-section';

const LicenseDetailsModal = (): React.JSX.Element => {
  // `selectCurrentLicenseDetails` reads from untyped `.js` state, so the license is `any`.
  const { admin, costCenter, productAccess } = useAppSelector(selectCurrentLicenseDetails);
  const dispatch = useAppDispatch();
  const hideModal = (): void => {
    dispatch(CloudAdminActions.hideModal());
  };

  return (
    <FjModal
      size="lg"
      accept={{
        text: 'OK',
        callback: () => hideModal(),
      }}
    >
      <div className="display-flex full-height">
        <div className="width-percentage-50">
          <LicenseDetailSection title="Info" className="min-height-percentage-60">
            {`${admin.firstname} ${admin.lastname}`} <br />
            {costCenter.name} <br />
          </LicenseDetailSection>
          <LicenseDetailSection title="Products">
            {`${productAccess.name} – ${productAccess.type}`}
          </LicenseDetailSection>
        </div>
        <div className="width-percentage-50">
          <LicenseDetailSection title="Contact" className="min-height-percentage-60">
            {admin.primaryEmail} <br />
            Phone Number TODO
            {/* TODO add phone number when available */}
          </LicenseDetailSection>
          <LicenseDetailSection title="Next Billing Date">
            {formatDate(productAccess.endDate)}
          </LicenseDetailSection>
        </div>
      </div>
    </FjModal>
  );
};

export default LicenseDetailsModal;
